












































































































import Vue from 'vue';
import LearningTools from '@/tools/learning';
import BbTools from '@/tools/bluebird';
import { Phrase, QuizPhrase, RapidTestResponse } from '@/store/types';
import AccessibleButton from '@/components/ui/AccessibleButton.vue';
import Activity from '@/components/activity/Activity.vue';
import ActivityStatus from '@/components/activity/ActivityStatusText.vue';
import BottomScores from '@/components/activity/BottomScores.vue';

export default Vue.extend({
  components: {
    activity: Activity,
    'accessible-button': AccessibleButton,
    'activity-status': ActivityStatus,
    'bottom-scores': BottomScores,
  },
  props: {
    videoPlayer: Object as () => any,
    showHint: Boolean,
    videoActivity: Boolean,
    nativeAudioMode: Boolean,
    nativePhrasesMode: Boolean,
    hidePossible: Boolean,
    playAudioAtStart: Boolean,
    quizPhrase: Object as () => QuizPhrase,
    activityIndex: Number,
    activityDataLength: Number,
    averageScore: Number,
    isRapidTest: Boolean,
  },
  data() {
    return {
      radioAnswer: null as Phrase | null,
      quizAnswer: null as Phrase | null,
      showList: false,
      originalHideNative: false,
      lockInput: false,
      nextQuestionResponse: null as RapidTestResponse | null,
    };
  },
  watch: {
    radioAnswer(val) {
      if (val) {
        this.onAnswer(val);
      }
    },
  },
  mounted() {
    this.originalHideNative = this.$store.state.hideNative;
    this.hideNative();
  },
  computed: {
    nativeComputed(): string {
      if (this.$store.state.hideNative) {
        return LearningTools.PHRASE_HIDDEN;
      }
      return (this.quizPhrase && this.quizPhrase.phrase) ? this.quizPhrase.phrase.native_word : '';
    },
    hintLabel(): string {
      if (this.$store.state.hideNative) {
        return this.$store.state.tr.HintDisplay;
      }
      return this.$store.state.tr.HintHide;
    },
  },
  methods: {
    activityReady() {
      this.hideNative();
      this.showList = true;
      if (this.playAudioAtStart) {
        (this.$refs.activity as any).startPlaying();
      } else if (this.$store.getters.isSignLang) {
        (this.$refs.activity as any).playActivityPlayerOnly();
      }
    },
    hideNative() {
      if (this.hidePossible && !this.$store.state.hideNative) {
        this.$store.commit('hideNative');
      }
    },
    showNative() {
      if (this.hidePossible && this.$store.state.hideNative) {
        this.$store.commit('hideNative');
      }
    },
    onNative() {
      if (this.hidePossible) {
        this.$store.commit('hideNative');
      }
    },
    onActivityStopped() {
      this.showList = false;
      this.quizAnswer = null;
    },
    getPhraseText(phrase: Phrase) {
      if (this.$store.state.user.phoneticMode && phrase.phonetic && phrase.phonetic !== '') {
        return phrase.phonetic;
      }
      return phrase.word;
    },
    async onAnswer(phrase: Phrase) {
      if (this.quizAnswer) {
        return;
      }
      (this.$refs.activity as any).pauseAllAudio();
      if (this.$store.state.sleepPromise) {
        this.$store.state.sleepPromise.cancel();
      }

      let answerCorrect = this.quizPhrase.phrase && this.quizPhrase.phrase.word === phrase.word;

      if (this.isRapidTest) {
        this.lockInput = true;
        this.nextQuestionResponse = await LearningTools.setAnswerAndGetNextRapidTestPhrase(
          this.$store,
          this.$router,
          this.quizPhrase.quizType,
          phrase.word,
        );
        if (!this.nextQuestionResponse) {
          return;
        }
        answerCorrect = phrase.word === this.nextQuestionResponse.data.previous_qz_answer.word;
        this.lockInput = false;
      }

      this.quizAnswer = phrase;
      this.radioAnswer = phrase;
      this.showNative();
      let score = 0;
      if (answerCorrect) {
        score = 1;
      }
      this.$emit('onScoreResult', score);
      if (this.$refs.activityStatus) {
        (this.$refs.activityStatus as any).updateScore(score, '');
      }
      await BbTools.sleepCancelable(LearningTools.TO_START_PLAYING, this.$store);
      (this.$refs.activity as any).startPlaying(this.nextQuestionResponse
        && this.nextQuestionResponse.data.previous_qz_answer);
    },
    audioPlayed() {
      if (this.quizAnswer) {
        this.showList = false;
        this.radioAnswer = null;
        this.quizAnswer = null;
        this.$emit('checkQuizEndOrNext', this.nextQuestionResponse);
      }
    },
    answerClass(phrase: Phrase) {
      let result = 'activity-phrase noselect stroketext mb-0 ml-4 pt-2 font-weight-medium text-left';
      if (this.radioAnswer) {
        const quizPhraseToCompare = this.isRapidTest
          ? this.nextQuestionResponse.data.previous_qz_answer
          : (this.quizPhrase && this.quizPhrase?.phrase);
        if (quizPhraseToCompare?.word === phrase.word) {
          result += ' green--text';
        } else if (this.radioAnswer !== phrase) {
          result += ' link--text';
        } else {
          result += ' red--text';
        }
      } else {
        result += ' link--text';
      }
      return result;
    },
    radioColor(phrase: Phrase) {
      let radioColor = '';
      if (this.radioAnswer && this.radioAnswer === phrase) {
        const quizPhraseToCompare = this.isRapidTest
          ? this.nextQuestionResponse.data.previous_qz_answer
          : (this.quizPhrase && this.quizPhrase?.phrase);
        if (quizPhraseToCompare?.word === phrase!.word) {
          radioColor = ' green';
        } else {
          radioColor = ' red';
        }
      }
      return radioColor;
    },
  },
  beforeDestroy() {
    if (this.$store.state.sleepPromise) {
      this.$store.state.sleepPromise.cancel();
    }
    if (this.hidePossible && this.originalHideNative !== this.$store.state.hideNative) {
      this.$store.commit('hideNative');
    }
  },
});
